// ---------------------------------------------------------------------------------

const MYPRO_QJBY_REDPKG = resolve => require(['../components/views/redpkg'], resolve);
const MYPRO_QJBY_APPDOWN = resolve => require(['../components/views/appdown'], resolve);
const MYPRO_QJBY_CHANNEL = resolve => require(['../components/views/channel'], resolve);

const MYPRO_QJBY_PRIVACY = resolve => require(['../components/views/privacy'], resolve);
const MYPRO_QJBY_PRIVACY2 = resolve => require(['../components/views/privacy2'], resolve);
const MYPRO_QJBY_APPDETAIL = resolve => require(['../components/views/appdetail'], resolve);

const MYPRO_COMM_ERROR = resolve => require(['../components/views/error'], resolve);

const funcs = [
  {
    path: '/',
    name: 'MYPRO-HOME',
    component: MYPRO_QJBY_APPDOWN, 
  },
  {
    path: '/error/:id?',
    name: 'MYPRO-COMM-ERROR',
    component: MYPRO_COMM_ERROR,
  },
  {
    path: '/app_detail',
    name: 'MYPRO-COMM-APPDETAIL',
    component: MYPRO_QJBY_APPDETAIL,
  },
  {
    path: '/user_privacy',
    name: 'MYPRO-COMM-PRIVACY',
    component: MYPRO_QJBY_PRIVACY,
  },
  {
    path: '/user_privacy2',
    name: 'MYPRO-COMM-PRIVACY2',
    component: MYPRO_QJBY_PRIVACY2,
  },
  {
    path: '/appdown',
    name: 'MYPRO-QJBY-APPDOWN',
    component: MYPRO_QJBY_APPDOWN,
  },
  {
    path: '/channel/:id',
    name: 'MYPRO-QJBY-CHANNEL',
    component: MYPRO_QJBY_CHANNEL,
  },
  {
    path: '/redpkg',
    name: 'MYPRO-QJBY-REDPKG',
    component: MYPRO_QJBY_REDPKG,
  },
  // 一定要在最后
  {
    path: '*',
    component: 404,
    meta: { requiresAuth: true }
  }
];

export default funcs;



// WEBPACK FOOTER //
// ./src/vuex/menus.js